<input #inputElement [type]="showPassword ? 'text' : 'password'" [class]="class"
       (change)="writeValue($event.target.value)" [autocomplete]="autocomplete" [attr.tabindex]="tabStart">
<i class="position-absolute cr-icon fa show-password-icon" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
   (click)="showPassword = !showPassword"></i>